import { getDmService } from '../../services/Api';
import { Administrador, Criacao, GerenteComercial } from '../../config/UserStatusLevel';

const RECEIVE_COUNTERS_DATA = 'RECEIVE_COUNTERS_DATA';
const RECEIVE_BADGETS_DATA = 'RECEIVE_BADGETS_DATA';
const TOGGLE_ADMIN_MENU = 'TOGGLE_ADMIN_MENU';
const TOGGLE_MY_STORES = 'TOGGLE_MY_STORES';
const MY_STORES = 'MY_STORES';

const INITIAL_STATE = {
  totalPedidosPendentes: 0,
  totalProdutosCarrinho: 0,
  badgets:null,
  showAdminMenu: JSON.parse(localStorage.getItem('showAdminMenu')) || false,
  showMyStores: JSON.parse(localStorage.getItem('showMyStores')) || false,
  stores: null
};

export const reducer = (prevState = INITIAL_STATE, action) => {
  if (action.type === RECEIVE_COUNTERS_DATA) {
    return { ...prevState, ...action.payload };
  }
  if (action.type === RECEIVE_BADGETS_DATA) {
    return { ...prevState, badgets: action.payload };
  }
  if (action.type === TOGGLE_ADMIN_MENU) {
    return { ...prevState, showAdminMenu: !prevState.showAdminMenu };
  }
  if (action.type === TOGGLE_MY_STORES) {
    return { ...prevState, showMyStores: !prevState.showMyStores };
  }
  if (action.type === MY_STORES) {
    return { ...prevState, stores: action.payload };
  }
  return prevState;
};

/* ------- Actions ------ */
const receiveCounters = () => async dispatch => {
  const user = await localStorage.getItem("user");
  const userObj = await JSON.parse(user);
  const permission = await userObj && userObj.nivel ? userObj.nivel.id : null;

  if((permission && permission !== Criacao) && (permission && permission !== GerenteComercial) ){
    try {
      const data = await getDmService('Usuario/Contadores');
      dispatch({
        type: RECEIVE_COUNTERS_DATA,
        payload: data,
      });
    } catch (e) {
      console.error(e);
    }
  }
};

const receiveBadget = () => async dispatch => {
  const user = JSON.parse(localStorage.getItem('user')) || { nivel: {} };
    // console.log("user", user)
  if(user.nivel.id === Administrador) {
    try {
      const badgets = await getDmService(
        '/Usuario/GetBadgets'
      );

      dispatch({
        type: RECEIVE_BADGETS_DATA,
        payload: badgets,
      });;
    } catch (ex) {
      console.log(ex);
    }
  }
};

const toggleAdminMenu = () => (dispatch, getState) => {
  const { showAdminMenu } = getState().main;
  dispatch({ type: TOGGLE_ADMIN_MENU });
  localStorage.setItem('showAdminMenu', JSON.stringify(!showAdminMenu));
};

const toggleMyStores = () => (dispatch, getState) => {
  const { showMyStores } = getState().main;
  dispatch({ type: TOGGLE_MY_STORES });
  localStorage.setItem('showMyStores', JSON.stringify(!showMyStores));
};

const myStores = () => async dispatch => {
  // const user = JSON.parse(localStorage.getItem('user')) || { nivel: {} };
  // const userObj = await JSON.parse(user);
  // if (user.nivel.id === Interno) {
    try {
      const stores = await getDmService('/Usuario/GetMyStores');
      dispatch({
        type: MY_STORES,
        payload: stores,
      });
    } catch (ex) {
      console.log(ex);
    }
 // }  
};

export default {
  receiveCounters,
  receiveBadget,
  toggleAdminMenu,
  toggleMyStores,
  myStores
};



// WEBPACK FOOTER //
// ./src/redux/modules/main.js